'use client'

import type { ConsentGateProps } from '@maestro/data-layer'

import { useCookiebotConsentGate } from '@maestro/cookiebot-cookie-consent/components/cookiebot-consent-gate/batons/use-cookiebot-consent-gate'
import { Icon } from '@pearlconvert/ui/components/icon'

import '@maestro/cookiebot-cookie-consent/components/cookiebot-consent-gate/styles/cookiebot-consent-gate.scss'

export default function CookiebotConsentGate(props: ConsentGateProps) {
  const { children, contentType } = props
  const { consentGateEnabled, ready, hasConsent, text } =
    useCookiebotConsentGate(props)

  if (!consentGateEnabled) {
    return children
  }

  if (!ready) {
    return null
  }

  if (!hasConsent) {
    return (
      <div className="cookiebot-consent-gate">
        <Icon
          icon={contentType === 'video' ? 'play' : 'location'}
          className="cookiebot-consent-gate__icon"
        />
        <p className="cookiebot-consent-gate__text">{text}</p>
      </div>
    )
  }

  return children
}
